import Morizen1 from "../../../media/morizen/morizen1.png";
import Morizen2 from "../../../media/morizen/morizen2.jpg";
import Morizen3 from "../../../media/morizen/morizen3.jpg";
import Morizen4 from "../../../media/morizen/morizen4.png";
import Morizen5 from "../../../media/morizen/morizen5.png";
import Morizen6 from "../../../media/morizen/morizen6.png";

const morizenimages = [
  Morizen1,
  Morizen2,
  Morizen3,
  Morizen4,
  Morizen5,
  Morizen6,
];

export default morizenimages;
